<div class="csv-upload-compact">
  <h4>{{ i18n.t('vnm.csvUpload') }}</h4>
  <div class="upload-controls">
    <input
      type="file"
      id="csvFileInput"
      hidden
      (change)="onFileSelected($event)"
      accept=".csv,text/csv,application/csv"
    />
    <button
      type="button"
      class="spectrum-button spectrum-button--secondary"
      (click)="triggerFileInput()"
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 7V17M12 7L16 11M12 7L8 11"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      {{ i18n.t('vnm.selectCsv') }}
    </button>
    <span class="file-name" *ngIf="uploadedFileName">
      {{ uploadedFileName }}
    </span>
  </div>
</div>